import { ESPORTS, PERIODS } from '../constants/defaultValues';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { az, enGB } from 'date-fns/locale';
import { locale } from './translation';
import LocalStorage from './localStorage';
import { producerTypeEnum } from '../constants/enums';
import { EVENT_FILTER_OPTIONS } from '../constants/event-filters';

function parseValue(v) {
    // extract number (defaults to 0 if not present)
    let n = +(v.match(/\d+$/) || [0])[0];
    let str = v.replace(n, ''); // extract string part
    return [str, n];
}

function sortOutcomeValues(outcomes) {
    // console.log('NOT SORTED OUTCOMES', outcomes);
    if (outcomes && outcomes.length > 0) {
        let newOutcomes = [...outcomes];

        newOutcomes.sort(function (a, b) {
            a = parseValue(a.outcomeRefId);
            b = parseValue(b.outcomeRefId);

            // compare string part alphabetically
            let result = a[0].localeCompare(b[0]);
            // if the string part is the same, compare the number part
            return result === 0 ? a[1] - b[1] : result;
        });

        return newOutcomes;
    }

    // console.log('SORTED OUTCOMES', sortedValues);
    return [];
}

function mbnColorPicker(count) {
    if (count === 0) return '#2a2f3a';
    if (count === 1) return '#2e66bf';
    if (count === 2) return '#A29534';
    if (count === 3) return '#049616';
    return '#2a2f3a';
}

export const generateQuery = filters => {
    const query = {};

    if (filters.categories) {
        const selectedCategoryId = filters.categories.find(league => league.selected)?.id;

        switch (selectedCategoryId) {
            case EVENT_FILTER_OPTIONS.categories.all.id: {
                break;
            }
            default: {
                query['categoryId'] = selectedCategoryId;
            }
        }
    }

    if (filters.leagues) {
        const selectedLeagueId = filters.leagues.find(league => league.selected)?.id;

        switch (selectedLeagueId) {
            case EVENT_FILTER_OPTIONS.leagues.all.id: {
                break;
            }
            case EVENT_FILTER_OPTIONS.leagues.favorites.id: {
                query['isFavorite'] = true;
                break;
            }
            default: {
                query['leagueId'] = selectedLeagueId;
            }
        }
    }

    if (filters.periods) {
        const selectedPeriod = filters.periods.find(item => item.selected);

        if (selectedPeriod.id !== 'all') {
            const { startTime, endTime } = selectedPeriod.getRange();
            query.startDate = startTime;
            query.endDate = endTime;
        }
    }

    if (filters.orders) {
        query.sortId = filters.orders.find(order => order.selected).id;
    }

    return query;
};

export const checkEventsNextPage = (events, type, paginationLimit) => {
    let eventsCount = 0;

    if (type === EVENT_FILTER_OPTIONS.orders.byLeague.id) {
        events.forEach(season => {
            eventsCount += season.events?.length || 0;
        });
    } else if (
        type === EVENT_FILTER_OPTIONS.orders.byTime.id ||
        type === EVENT_FILTER_OPTIONS.orders.byMbn.id
    ) {
        eventsCount = events.length;
    }

    return eventsCount >= paginationLimit;
};

export const setDatePickerLocale = () => {
    if (locale === 'eng') {
        registerLocale('en-GB', enGB);
        setDefaultLocale('en-GB');
    } else if (locale === 'aze') {
        registerLocale('az', az);
        setDefaultLocale('az');
    }
};

export const getMoreMarketsUrl = ({ event }) => {
    if (!window.location.pathname.includes('/markets')) {
        LocalStorage.setItem('moreMarketsRedirectUrl', window.location.pathname);
    }

    const sportId = event.sportId || event.sportTypeRefId;

    const url = generateEventsUrl({
        isLive: event.live,
        isESports: isESportEvent(sportId),
        sportId,
    });

    return url + `/events/${encodeURIComponent(event.id)}/markets`;
};

export const getEventsUrl = ({ event }) => {
    const redirectUrl = LocalStorage.getItem('moreMarketsRedirectUrl');

    if (redirectUrl) return redirectUrl;

    const sportId = event.sportId || event.sportTypeRefId;

    return generateEventsUrl({
        isLive: event.live,
        isESports: isESportEvent(sportId),
        sportId,
    });
};

export const generateEventsUrl = ({ isLive, isESports, sportId }) => {
    let url = `${generateBaseSportsUrl({ isLive, isESports })}${encodeURIComponent(sportId)}`;

    return url;
};

export const generateBaseSportsUrl = ({ isLive, isESports }) => {
    let url = '/app/';

    if (isESports) {
        url += 'e-';
    }

    if (isLive) {
        url += 'live/';
    } else {
        url += 'sports/';
    }

    return url;
};

export const getSportIdParam = (pathname = '') => {
    return decodeURIComponent(pathname.split('/')[3]);
};

export const removeMoreMarketsRedirectUrl = () => {
    LocalStorage.removeItem('moreMarketsRedirectUrl');
};

export const getProducerType = isLive =>
    isLive ? producerTypeEnum.LIVE : producerTypeEnum.PRE_MATCH;

export const isOnlyESport = betLines => betLines?.every(bL => !!ESPORTS[bL.sportTypeId]);
export const isESportBetLine = betLine => !!ESPORTS[betLine.sportTypeId];
export const isESportEvent = sportId => !!ESPORTS[sportId];

export { sortOutcomeValues, parseValue, mbnColorPicker };

export async function downloadFile(getBlobData, fileName) {
    const blob = await getBlobData();

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute('download', fileName);

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export const generateCustomDate = (selectedPeriod, date) => {
    const period = selectedPeriod.key === PERIODS.custom.key ? selectedPeriod : PERIODS.custom;

    return {
        ...period,
        ...date,
    };
};
